export const OPEN_TOPIC_DIALOG = 'OPEN_TOPIC_DIALOG'
export const CLOSE_TOPIC_DIALOG = 'CLOSE_TOPIC_DIALOG'
export const SET_TOPIC_DIALOG_STATE = 'SET_TOPIC_DIALOG_STATE'
export const SET_TOPIC_DELETE_DIALOG_STATE = 'SET_TOPIC_DELETE_DIALOG_STATE'
export const TOPIC_VALID_FORM = 'TOPIC_VALID_FORM'
export const TOPIC_INVALID_FORM = 'TOPIC_INVALID_FORM'
export const TOPIC_SUBMIT_INIT = 'TOPIC_SUBMIT_INIT'
export const TOPIC_SUBMIT_SUCCESS = 'TOPIC_SUBMIT_SUCCESS'
export const TOPIC_NAME_ERROR = 'TOPIC_NAME_ERROR'
export const TOPIC_NAME_HASNT_ERROR = 'TOPIC_NAME_HASNT_ERROR'
export const DELETING = 'DELETING'
export const OPEN_ADD_SUBSCRIBERS = 'OPEN_ADD_SUBSCRIBERS'
export const CLOSE_ADD_SUBSCRIBERS = 'CLOSE_ADD_SUBSCRIBERS'
export const SET_SUBSCRIBERS_TOPICS = 'SET_SUBSCRIBERS_TOPICS'
export const GET_TOPIC_DETAIL = 'GET_TOPIC_DETAIL'
